<template>
  <v-container fluid>

    <v-card>

      <v-card-title>
        Presupuesto mensual por contratista
      </v-card-title>

      <v-card-text>

        <v-row>

          <v-col cols="12" md="6">

            <v-autocomplete
              v-model="presupuesto.id_empresa_contratista"
              :items="empresascontratistas"
              label="Empresa contratista"
              dense
              @change="buscarPresupuesto"
            />

          </v-col>

          <v-col cols="12" md="3">

            <v-select
              v-model="presupuesto.anio"
              :items="anios"
              label="Año"
              dense
              @change="buscarPresupuesto"
            />

          </v-col>

          <v-col cols="12" md="3">

            <v-select
              v-model="presupuesto.mes"
              :items="meses"
              item-text="text"
              item-value="value"
              label="Mes"
              dense
              @change="buscarPresupuesto"
            />

          </v-col>

          <v-col cols="12" md="4">

            <v-text-field
              v-model.number="presupuesto.presupuesto"
              label="Presupuesto mensual"
              prefix="S/"
              type="number"
              dense
            />

          </v-col>

        </v-row>

      </v-card-text>

      <v-card-actions>

        <v-spacer/>

        <v-btn
          color="primary"
          @click="guardar"
        >
          Guardar
        </v-btn>

      </v-card-actions>

    </v-card>

    <br>

    <v-card>

      <v-card-title>
        Historial
      </v-card-title>

      <v-data-table
        :headers="headers"
        :items="lista"
        dense
      >

        <template v-slot:item.presupuesto="{ item }">
          S/ {{ Number(item.presupuesto).toLocaleString() }}
        </template>

        <template v-slot:item.acciones="{ item }">

          <v-btn
            icon
            small
            @click="editar(item)"
          >
            <v-icon color="primary">
              mdi-pencil
            </v-icon>
          </v-btn>

        </template>

      </v-data-table>

    </v-card>

  </v-container>

</template>

<script>

  import axios from "axios";

  export default {

  data(){

    return{

    empresascontratistas:[],

    lista:[],

    anios:[],

    meses:[
      {text:'Enero',value:1},
      {text:'Febrero',value:2},
      {text:'Marzo',value:3},
      {text:'Abril',value:4},
      {text:'Mayo',value:5},
      {text:'Junio',value:6},
      {text:'Julio',value:7},
      {text:'Agosto',value:8},
      {text:'Septiembre',value:9},
      {text:'Octubre',value:10},
      {text:'Noviembre',value:11},
      {text:'Diciembre',value:12},
    ],

    presupuesto:{
      id_presupuesto:0,
      id_empresa_contratista:null,
      anio:new Date().getFullYear(),
      mes:new Date().getMonth()+1,
      presupuesto:null
      },

    headers:[

      {text:"Empresa",value:"empresa_contratista"},
      {text:"Año",value:"anio"},
      {text:"Mes",value:"mes"},
      {text:"Presupuesto",value:"presupuesto"},
      {text:"",value:"acciones",sortable:false}

    ]

    }

  },

  mounted(){

    this.selectempresa();

    this.cargarAnios();

    this.listar();

  },

  methods:{

    cargarAnios(){

      let actual=new Date().getFullYear();

      for(let i=actual-2;i<=actual+5;i++)
        this.anios.push(i);
      },

      selectempresa() {

      let me=this;

      axios.get("api/Contratistas/Select")
      .then(res=>{

      me.empresascontratistas=res.data.map(x=>({

      text:x.empresa_contratista,
      value:x.id_empresa_contratista

      }));

      });

    },

    listar(){

      axios.get("api/PresupuestoContratista/Listar")
      .then(res=>{

      this.lista=res.data;

      });

    },

    buscarPresupuesto(){

      if(!this.presupuesto.id_empresa_contratista)
        return;

      axios.get(

        `api/PresupuestoContratista/Obtener/${this.presupuesto.id_empresa_contratista}/${this.presupuesto.anio}/${this.presupuesto.mes}`

        )

        .then(res=>{

        if(res.data){

          this.presupuesto.id_presupuesto=res.data.id_presupuesto;

          this.presupuesto.presupuesto=res.data.presupuesto;

        }
        else{

          this.presupuesto.id_presupuesto=0;

          this.presupuesto.presupuesto=null;

        }

      });

    },

    guardar(){

      if(!this.presupuesto.id_empresa_contratista){

        alert("Seleccione una empresa");

        return;

      }

      if(!this.presupuesto.presupuesto){

        alert("Ingrese el presupuesto");

        return;

      }

      axios.post(

      "api/PresupuestoContratista/Guardar",

        this.presupuesto

      )

      .then(()=>{

        alert("Registro guardado correctamente");

        this.listar();

      })

      .catch(()=>{

        alert("Ocurrió un error");

      });

    },

    editar(item){

      this.presupuesto={

        id_presupuesto:item.id_presupuesto,

        id_empresa_contratista:item.id_empresa_contratista,

        anio:item.anio,

        mes:item.mes,

        presupuesto:item.presupuesto

      };

      }

    }

  }

</script>